export const dashboard = {
  myItems: "My items",
  global: "Global view",
  favorites: "Favorites",
  recents: "Recently viewed",
  treeNav: "Tree navigation",
  expand: "Expand",
  powerbi: "PowerBI Dashboard",
};
